// extracted by mini-css-extract-plugin
export default {"modal":"Lda-z","modalContent":"Mda-z","footer":"Nda-z","cancelBtn":"Oda-z","disabled":"Pda-z","formWrapper":"Qda-z","fade":"Rda-z","fade-in":"Sda-z","iframe":"Tda-z"};